import React from 'react';

export const defaultTheme = {
	primary: '#fa3752',
	secondary: '#009587',
	tertiary: '#394c6f',
	warning: '#ff974c',
	error: '#d50000',
	success: '#52bf52',
	defaultColor: '#464646',
};

const ThemeContext = React.createContext(defaultTheme);
export default ThemeContext;
